<template>
    <validation-observer ref="form" v-slot="{ meta, setFieldValue, errors }">
        <modal
            @hidden="clearData"
            @shown="setData"
            :id="modalId"
            :ok-disabled="!meta.valid"
            :title="title"
            @ok.prevent="submit"
        >
            <validation-provider name="product_name_custom" rules="required">
                <form-select
                    :options="customNamesOptions"
                    :error="errors.product_name_custom"
                    v-model="values.product_name_custom"
                    label="Name"
                    @change="(val) => setFieldValue('product_name_custom', val)"
                />
            </validation-provider>
            <validation-provider name="value" class="w-100" rules="required|validNumber">
                <form-input
                    :error="errors.value"
                    v-model="values.value"
                    label="Value"
                    @input="(val) => setFieldValue('value', val)"
                />
            </validation-provider>
            <form-select
                :options="collectionRulesOptions"
                :error="errors.override_universal_rules"
                v-model="values.override_universal_rules"
                @change="(val) => setFieldValue('override_universal_rules', val)"
            />
            <form-search-multiselect
                v-model="values.tax_exceptions"
                label="Taxes"
                :options="taxOptions"
                placeholder="Select Taxes"
            />

            <small> Edits will appear on all properties where the damage protection fee currently appears. </small>
        </modal>
    </validation-observer>
</template>

<script>
    import { mapGetters } from 'vuex';
    import formInput from '../../generic/form-input/form-input.vue';
    import formSelect from '../../generic/form-select/form-select.vue';
    import modal from '../../generic/modal/modal.vue';
    import formTextarea from '../../generic/form-textarea/form-textarea.vue';
    import formSearchMultiselect from '../../generic/form-search-multiselect/form-search-multiselect.vue';
    import { set } from 'lodash';

    export default {
        name: 'AddEditTaxModal',
        components: {
            formInput,
            formSelect,
            modal,
            formTextarea,
            formSearchMultiselect,
        },
        props: {
            initialData: {
                type: Object,
                default: null,
            },
            modalId: {
                type: String,
            },
        },
        data() {
            return {
                values: {
                    product_name_custom: '',
                    value: '',
                    override_universal_rules: false,
                    tax_exceptions: [],
                },
            };
        },
        computed: {
            ...mapGetters('propertyManager', ['metadata']),
            title() {
                return this.initialData ? 'Edit Damage' : 'Add Damage';
            },
            collectionRulesOptions() {
                return [
                    {
                        value: false,
                        text: 'Per Universal Rules',
                    },
                    {
                        value: true,
                        text: 'Fee due at time of booking',
                    },
                ];
            },
            customNamesOptions() {
                return this.initialData?.custom_names.map((item) => ({
                    value: item.id,
                    text: item.name,
                }));
            },
            taxOptions() {
                return this.metadata?.taxes.map((item) => ({
                    value: item.id,
                    text: item.title,
                }));
            },
        },
        methods: {
            submit() {
                this.$emit('submit', {
                    ...this.values,
                    tax_exceptions: this.taxOptions
                        .filter((item) => !this.values.tax_exceptions.includes(item.value))
                        .map((item) => item.value),
                });
            },
            setData() {
                if (this.initialData) {
                    this.values = {
                        ...this.initialData,
                        tax_exceptions: this.metadata?.taxes
                            .map((item) => item.id)
                            .filter((item) => !this.initialData.tax_exceptions.map((item) => item.tax).includes(item)),
                    };
                } else {
                    this.values = {
                        product_name_custom: '',
                        value: '',
                        override_universal_rules: false,
                        tax_exceptions: [],
                    };
                }
                this.$refs.form.setValues({
                    ...this.values,
                });
            },
            clearData() {
                this.$emit('hide');
                this.values = {
                    product_name_custom: '',
                    value: '',
                    override_universal_rules: false,
                    tax_exceptions: [],
                };
            },
        },

        watch: {
            initialData() {
                this.setData();
            },
        },
    };
</script>

<style scoped>
    .input-wrapper {
        gap: 1rem;
    }
</style>
